import React from "react";

const PageHeader = ({ title, subtitle, actions, children }) => {
  const rightContent = actions || children;

  return (
    <div className="page-header mb-24 d-flex align-items-center justify-content-between flex-wrap gap-3">
      <div className="page-header-left">
        <h4 className="page-title mb-0">{title}</h4>
        {subtitle && (
          <p className="page-subtitle text-secondary-light text-sm mb-0 mt-1">
            {subtitle}
          </p>
        )}
      </div>

      {rightContent && (
        <div className="page-header-right d-flex align-items-center flex-wrap gap-3">
          {rightContent}
        </div>
      )}
    </div>
  );
};

export default PageHeader;

